import React from "react";
import { string } from "prop-types";

import DartyLogo from "@components/shared/Icons/Darty";
import FNACLogo from "@components/shared/Icons/FNAC";
import HomeTDLogo from "@components/shared/Icons/HomeTDLogo";
import CitroenLogo from "@components/shared/Icons/Citroen";
import MediaMarktLogo from "@components/shared/Icons/MediaMarktLogo";
import FnacDartyIconContainer from "@components/shared/FnacDartyIconContainer";

import { getStaticAssetURL } from "@lib/getStaticAssetURL";
import { testDriveLocationType } from "@types";

import {
  TEST_DRIVE_TYPE_ID,
  TEST_DRIVE_POINT_STORE_TYPE,
} from "@shared/constants";

const ResultItemLogo = ({ testDrivePoint }) => {
  const baseProps = {
    width: "2.5rem",
    height: "2.5rem",
    dataId: `point-logo-${testDrivePoint.storeType}`,
  };

  switch (testDrivePoint.storeType) {
    case TEST_DRIVE_POINT_STORE_TYPE.DARTY:
      return <DartyLogo {...baseProps} />;

    case TEST_DRIVE_POINT_STORE_TYPE.FNAC:
      return <FNACLogo {...baseProps} />;

    case TEST_DRIVE_POINT_STORE_TYPE.HOME:
      return <HomeTDLogo {...baseProps} />;

    case TEST_DRIVE_POINT_STORE_TYPE.MEDIAMARKT:
      return (
        <MediaMarktLogo data-id={`point-logo-${testDrivePoint.storeType}`} />
      );
  }

  if (testDrivePoint.id === TEST_DRIVE_TYPE_ID.FNAC_DARTY) {
    return (
      <FnacDartyIconContainer dataId={`point-logo-${testDrivePoint.id}`} />
    );
  }
  if (testDrivePoint.type === TEST_DRIVE_TYPE_ID.SUPER) {
    return (
      <img
        width={40}
        height={40}
        data-id={`point-logo-${testDrivePoint.id}`}
        src={getStaticAssetURL(`/images/testDrive/super_fan_logo.png`)}
      />
    );
  }

  return <CitroenLogo data-id={`point-logo-${testDrivePoint.storeType}`} />;
};

ResultItemLogo.propTypes = {
  storeType: string,
  color: string,
  testDrivePoint: testDriveLocationType,
};

export default ResultItemLogo;
